import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ILead, IDropdown, IPlanStatusDropdown } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVInput } from "../../shared/JVInput";
import { JVDate } from "../../shared/JVDate";
import { format } from "date-fns";


const schema = yup.object({

});

interface Iprops {
    tableData: [],
    open: boolean,
    hideDialoge: () => void,
    toast: any,
    singleData: any,
    reloadData: () => void,

}
interface IPlanDrop extends IDropdown {
    plan_Cost?: number
}
export const RenewPlan = (props: Iprops) => {
    const [status, setStatus] = useState<IDropdown[]>();
    const [submitting, setSubmitting] = useState(false);
    const [plan, setPlan] = useState<IPlanDrop[]>();

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<any>({
        resolver: yupResolver(schema),
        //defaultValues: props.tableData,
        shouldFocusError: false,
    });

    const planName = watch("plan_ID");
    const noOfConnections = watch("no_Of_Connections") || 0;
    const planCost = plan?.find((item) => item.id === planName)?.plan_Cost || 0;
    setValue("base_Price", planCost);

    useEffect(() => {
        loadStatus();
        loadPlan();
    }, []);

    const loadStatus = async () => {
        const response = await Fetch("status/dropdown", "GET", null, null, null);
        if (response) {
            setStatus(await response.json());
        }
    }

    const tdStyle = {
        padding: '10px',
        border: '1px solid #dee2e6',
        color: '#212529',
    };


    const loadPlan = async () => {
        const response = await Fetch("subscription_Plan/dropdown", "GET", null, null, null);
        if (response) {
            setPlan(await response.json());
        }
    }

    const onHide = () => {
        props.hideDialoge();
        reset({});
    }

    const saveToDB = async (body: any) => {
        setSubmitting(true);
        body.plan_start_Date = props.singleData.expectedActivationDate;
        body.plan_Expiry_Date = props.singleData.expiryDate;
        body.planStatus_id = props.singleData.planStatus_id;
        if (body.expectedActivationDate) {
            body.expectedActivationDate = format(new Date(body.expectedActivationDate), 'yyyy-MM-dd') as any;
        }
        const response = await Fetch(`Customer${props.singleData.customerDeviceID ? '/' + props.singleData.customerDeviceID : ''}`, "PUT", body, null, props.toast);

        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: "Updated Successfully", life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    function onSubmit(data: ILead) {
        if (Number(data.deal_Price) > Number(data.base_Price)) {
            props.toast.current.show({ severity: 'error', detail: "Deal Price cannot be greater than Base Price", life: 3000 });
            return;
        }
        saveToDB(data);
    }
    console.log(props.singleData)

    return (
        <Dialog visible={props.open} style={{ width: '50vw' }} header={<h2 style={{ margin: 0 }}>Renew Plan</h2>} modal className="p-fluid" onHide={onHide}
        >            <div style={{ padding: '1rem 0' }}>
                <div style={{ padding: '1rem' }}>
                    <h4 style={{ marginBottom: '1rem', color: '#343a40' }}>
                        Plan History Of | {props.singleData.contact_Person_Name}
                    </h4>
                    <table
                        style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            fontFamily: 'Arial, sans-serif',
                            fontSize: '14px',
                            boxShadow: '0 0 10px rgba(0,0,0,0.05)',
                        }}
                    >
                        <thead style={{ backgroundColor: '#f8f9fa' }}>
                            <tr>
                                {['Plan Name', 'Base Price($)', 'Deal Price($)', 'Plan Date', 'Expiry Date'].map((header) => (
                                    <th
                                        key={header}
                                        style={{
                                            padding: '10px',
                                            border: '1px solid #dee2e6',
                                            textAlign: 'left',
                                            fontWeight: 'bold',
                                            color: '#495057',
                                        }}
                                    >
                                        {header} <span style={{ cursor: 'pointer' }}></span>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={tdStyle}>{props.singleData.planName}</td>
                                <td style={tdStyle}>{props.singleData.base_Price}</td>
                                <td style={tdStyle}>{props.singleData.deal_Price}</td>
                                {/* <td style={tdStyle}>{props.singleData.Price}</td> */}

                                <td style={tdStyle}>
                                    {new Date(props.singleData.expectedActivationDate).toLocaleDateString()}
                                </td>
                                <td style={tdStyle}>
                                    {new Date(props.singleData.expiryDate).toLocaleDateString()}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid ml-1 mr-1">
                    <JVDropdown column={3} label="Select Plan" control={control} options={plan} optionLabel="plan_Name" optionValue="id" name="plan_ID" placeholder="Select Status" />
                    <JVInput column={3} label="Base Price($)" control={control} name="base_Price" type="number" />
                    <JVInput column={3} label="Deal Price($)" control={control} name="deal_Price" type="number" />
                    <JVDate column={3} label="EA Date" control={control} name="expectedActivationDate" tooltip="Expected Activation Date – choose the date device should activate" />

                    <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                        <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                        <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                    </div>
                </form>
            </div>
        </Dialog>
    );
}